<style>

    kendo-datepicker.k-date-picker {
        border: none !important;
    }

    ::ng-deep kendo-datepicker button {
        background: transparent !important;
    }

</style>

<div class="row">
    <notification-trace-results
	    [traceResults]="context.data"
	    [nightMode]="nightMode">
    </notification-trace-results>
    <br>
    <div class="col-md-6" *ngIf="!destinationToStorage">
        <h4>Approval of this notification will:</h4>
        <ul>
            <li>Update railcar status to <b>Scrapped</b></li>
            <li *ngIf = "!!context && !!context.lease">Set Return Date on lease # <b>{{context.lease.rider}}</b> to <b>{{context.value | date: 'MM-dd-yyyy'}}</b></li>
            <li *ngIf = "isRequestRecieverForm == true">Email will be sent to scrap location requesting the receiver form</li>
        </ul>
    </div>
    <div class="col-md-6" *ngIf="destinationToStorage">
        <h4>Approval of this notification will:</h4>
        <ul>
            <li>Update railcar status to <b>InStorage</b></li>
            <li *ngIf = "!!context && !!context.lease">Set Return Date on lease # <b>{{context.lease.rider}}</b> to <b>{{context.value | date: 'MM-dd-yyyy'}}</b></li>
           </ul>
    </div>
    <div class="col-md-2">
        <div style="width: 125px;">
            <kendo-datepicker *ngIf="!!context"
                [(ngModel)]="context.value"
                [ngClass]="{'night-mode': nightMode}"
                class="k-date-picker"
                formatPlaceholder="short"
                [max]="currentDate"
                (valueChange)="dateChanged()"></kendo-datepicker>
            <label class="service-event-date-label" style="font-weight: bold;">Arrival Date</label>
        </div>
    </div>
    <div class="col-md-4" *ngIf="!destinationToStorage">
        <div class="row">
            <div class="col-md-6">
                <label>Request Receiver Form</label>
            </div>
            <div class="col-md-6">
                <kendo-buttongroup class="notification-button-group" [selection]="'single'" name="requestReceiverForm" id="requestReceiverForm" >
                    <button class="notification-button-group" kendoButton [selected]="isRequestRecieverForm == true" [togglable]="true" (click) ="changeRequestReview(true)" >Yes</button>
                    <button class="notification-button-group" kendoButton [selected]="!(isRequestRecieverForm == true)" [togglable]="true" (click) ="changeRequestReview(false)">No</button>
                </kendo-buttongroup>
            </div>
        </div>
    </div>
</div>
